import React, { Component } from "react";
import BaseConfig from "../../../../components/BaseConfig";

import api from "../../../../services/api";
import * as Permissions from "../../../../services/permissions";
import { Spin, Table, Button, Alert } from "antd";
import Actions from "./Actions";
import Cadastro from "./Cadastro";

export default class TiposAcordo extends Component {
  /**
   * Gerencia os tipos de acordo
   */
  state = {
    loading: false,
    tipos: null,
    error: null,
    visible: false
  };

  componentDidMount() {
    this.handleTiposAcordos();
  }

  handleTiposAcordos = async () => {
    // Obtém os tipos de acordo cadastrados
    await api
      .get("/tipo_acordo/")
      .then(response => {
        const types = response.data;

        this.setState({
          tipos: types
        });
      })
      .catch(err => {
        console.log(err);

        this.setState({
          error: "Não foi possível obter os tipos de acordos cadastrados."
        });
      });

    this.setState({
      loading: false
    });
  };

  handleTypes = () => {
    const data = [];

    if (this.state.tipos !== null && this.state.tipos !== undefined) {
      this.state.tipos.map(obj => {
        data.push({
          key: obj.id,
          tipo: obj.tipo,
          porcentagem:
            obj.porcentagem_honorarios == null
              ? "0%"
              : `${obj.porcentagem_honorarios}%`,
          actions: <Actions tipo={obj} handleTypes={this.handleTiposAcordos} />
        });
      });
    }

    return data;
  };

  handleCadastro = () => {
    this.setState({
      visible: true
    });
  };

  handleCadastroCancel = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const columns = [
      {
        title: "Tipo",
        dataIndex: "tipo"
      },
      {
        title: "Porcentagem honorários",
        dataIndex: "porcentagem"
      },
      {
        title: "Ações",
        dataIndex: "actions"
      }
    ];

    if (!Permissions.has("acordo.acordo_conf_tipos_acordo")) {
      return (
        <BaseConfig
          title="Tipos de acordo"
          subtitle="Gerencie os tipos de acordo"
        >
          <div style={{ padding: "15px", textAlign: "center" }}>
            <Alert type="warning" message="Sem permissão." />
          </div>
        </BaseConfig>
      );
    }

    return (
      <BaseConfig
        title="Tipos de acordo"
        subtitle="Gerencie os tipos de acordo"
      >
        <div style={{ padding: "15px", textAlign: "center" }}>
          {this.state.loading ? (
            <Spin />
          ) : (
            <div>
              <div style={{ textAlign: "end", marginBottom: "5px" }}>
                <Button
                  className="btn-green"
                  icon="plus"
                  type="primary"
                  onClick={this.handleCadastro}
                >
                  Novo
                </Button>
                <Cadastro
                  visible={this.state.visible}
                  handleCadastroCancel={this.handleCadastroCancel}
                  handleTypes={this.handleTiposAcordos}
                />
              </div>
              <Table
                columns={columns}
                dataSource={this.handleTypes()}
                pagination={false}
              />
            </div>
          )}
        </div>
      </BaseConfig>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Configuracoes/Acordo/TiposAcordo/index.js